/**
 * Ritorna la dimensione del componente.
 * @param {DOMElement} element elemento del dom
 * @returns {object} oggetto con width, height
 */
export function getElementSize(element = {}) {
  return { width: element.clientWidth, height: element.clientHeight };
}

/**
 * Ritorna informazioni sulla dimensione della viewport.
 * @param {DOMElement} element elemento del dom
 */
export function getViewportSize() {
  return { width: window.innerWidth, height: window.innerHeight };
}

/**
 * Ritorna informazioni sulla dimensione e posizionamento del componente.
 * @param {DOMElement} element elemento del dom
 * @returns {DOMRect}
 */
export function getRect(element) {
  if (element && element.getBoundingClientRect) return element.getBoundingClientRect();
  return {};
}
